module.exports = __webpack_public_path__ + "static/media/eraser.b1d6e5c9.svg";